export const SERVER_URI = 'https://rs-lang-server-part.herokuapp.com';
